export const pubReleaseTypes = {
  PUB_RELEASE_ONCHANGE: "PUB_RELEASE_ONCHANGE",
  SELECTED_PUB_REL_CATEGORY: "SELECTED_PUB_REL_CATEGORY",
  PUB_RELEASES_FILTER_DATA: "PUB_RELEASES_FILTER_DATA",
  SELECTED_PUB_REL_FILTER: "SELECTED_PUB_REL_FILTER",
  DISPLAY_PUB_REL_FILTER: "DISPLAY_PUB_REL_FILTER",
  CLEAR_PUB_REL_FILTER: "CLEAR_PUB_REL_FILTER",
};
